import { createReducer, on } from '@ngrx/store';
import {
  initialCartState,
  initialDeliveryDetailsState,
  initialProductDetailsState,
} from './cement-state';
import {
  deliveryDetails,
  deliveryDetailsMaster,
  inco_term,
  local_purchase_number,
  payer,
  plant,
  products,
  setCart,
  ship_tos,
  setProductsAction,
  setrotationCart,
} from './cement.action';

const _cartReducer = createReducer(
  initialCartState,
  on(payer, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      payer: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(deliveryDetails, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      deliveryDetails: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(ship_tos, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      ship_tos: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(plant, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      plant: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(products, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      products: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(setCart, (state: any, action) => {
    return {
      ...state,
      cartData: action.data,
    };
  }),

  on(inco_term, (state: any, action) => {
    let cartData = {
      ...state.cartData,
      inco_term: action.data,
    };
    return {
      ...state,
      cartData: cartData,
    };
  }),

  on(setrotationCart, (state: any, action) => {
    return {
      ...state,
      rotationCartData: action.data,
    };
  })
);

const _deliverydetailsReducer = createReducer(
  initialDeliveryDetailsState,
  on(deliveryDetailsMaster, (state: any, action) => {
    return {
      ...state,
      deliveryDetailsMaster: action.data,
    };
  }),

  on(local_purchase_number, (state: any, action) => {
    return {
      ...state,
      local_purchase_number: action.data,
    };
  })
);

const _productDetailsReducer = createReducer(
  initialProductDetailsState,
  on(setProductsAction, (state: any, action) => {
    return {
      ...state,
      ...action.data,
    };
  })
);

export function cartReducer(state: any, action: any) {
  return _cartReducer(state, action);
}

export function deliverydetailsReducer(state: any, action: any) {
  return _deliverydetailsReducer(state, action);
}

export function productDetailsReducer(state: any, action: any) {
  return _productDetailsReducer(state, action);
}
